<template>
  <div id="demo-basic-card">

    <vs-alert color="danger" title="User Not Found" :active.sync="module_not_found">
        <span>Module record with id: {{ $route.params.moduleId }} not found. </span>
        <span>
            <span>Check </span><router-link :to="{name:'modules'}" class="text-inherit underline">All Modules</router-link>
        </span>
    </vs-alert>

    <div id="module-data" v-if="module_data">
        <vx-card :title="module_data.name" class="mb-base">
            <template   slot="actions">
                <vx-tooltip :text="'Edit '+module_data.name" position="left">
                    <feather-icon @click="redirectToEditModule()" icon="EditIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                </vx-tooltip>
            </template>

            <div class="carousel-example" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
                <swiper :options="swiperOption">
                    <swiper-slide>
                        <img class="responsive" :src="module_data.image" alt="banner">
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>

            <vs-list>
                <vs-list-item title="Name" :subtitle="module_data.name"></vs-list-item>
                <vs-list-item title="Duration" :subtitle="module_data.hours+' Minutes'"></vs-list-item>
                <vs-list-item title="Type" :subtitle="module_data.type"></vs-list-item>
                <vs-list-item title="Status" :subtitle="module_data.status"></vs-list-item>
                <vs-list-item title="Tags" subtitle="Description">
                    <vs-chip v-for="(listItem, index) in module_data.tags" :key="index">{{ listItem.description }}</vs-chip>
                </vs-list-item>
            </vs-list>
        </vx-card>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleModuleManagement from '@/store/module-management/moduleModuleManagement.js'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default{
    data() {
        return {
            module_data: null,
            module_not_found: false,
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination'
                }
            }
        }
    },
    components: {
        VuePerfectScrollbar,
        swiper,
        swiperSlide,
    },
    methods: {
        redirectToEditModule() {
            this.$router.push("/modules/edit/" + this.module_data.id).catch(() => {})
        },
    },
    created() {
        if(!moduleModuleManagement.isRegistered) {
            this.$store.registerModule('moduleManagement', moduleModuleManagement)
            moduleModuleManagement.isRegistered = true
        }

        const moduleId = this.$route.params.moduleId
        this.$store.dispatch("moduleManagement/getAModule", moduleId)
            .then(res => { this.module_data = res.data })
            .catch(err => {
                if(err.response.status === 404) {
                    this.module_not_found = true
                    return
                } 
            })
    },

}
</script>

